import React from 'react';
import './Modal.css'

interface ViewImageModalProps {
  src: string;
  onClose: Function;
}

class ViewImageModal extends React.Component<ViewImageModalProps, {}> {
  constructor(props:ViewImageModalProps) {
    super(props);
  }

  componentDidMount() {
    console.log('ViewImageModal mounted');
  }


  render() {
    return (
      <div className="modal open" onClick={(e:any)=>e.stopPropagation()}>
        <div style={{display: 'flex', flexDirection: 'column', backgroundColor: 'black', height: '100%', position: 'relative'}} onClick={()=>this.props.onClose()}>
          <button 
            className="modal-close-button"
            onClick={(e) => {
              e.stopPropagation();
              this.props.onClose();
            }}
            style={{position: 'absolute', right: '10px', top: '10px', zIndex: 10, background: 'rgba(0,0,0,0.5)', border: 'none', borderRadius: '50%', width: '40px', height: '40px', color: 'white', fontSize: '24px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center'}}
          >
            ×
          </button>
          <img style={{objectFit: 'scale-down', width: '100%', height: '100%'}} src={this.props.src} />
        </div>
      </div>
    )
  }
}

export default ViewImageModal;